import i18next, { TFunction } from 'i18next';
import { commonPaths } from '../../types/locales';
import { CommercialListing } from 'data/commercial/types';
import { listingConfig } from '@tenants/definitions/exp/commercial/listing-config';


function getPluralizedText(key: commonPaths, count: number, additionalOptions = {}, t?: TFunction) {
  if (t) {
    return t(key, { count, ...additionalOptions });
  }
  return i18next.t(key, { count, ...additionalOptions });
}

export function getDaysText(count: number, t?: TFunction) {
  return getPluralizedText('common:plurals.days_with_count', count, {}, t);
}

export function getUpperDaysText(count: number) {
  return getPluralizedText('common:plurals.upper_days_with_count', count);
}

export function getCommercialFullAddress(t: TFunction, listing: CommercialListing ) {
  return t(listingConfig.fullAddress, {
    streetAddress: listing.unparsedAddress || '',
    city: listing.city || '',
    province: listing.stateOrProvince || '',
    postalCode: listing.standardizedAddress?.postalCode || '',
    country: listing.country || '',
  });
}